(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-redemption"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('decanter-gift-redemption')) {
    class DecanterGiftRedemption extends HTMLElement {
      constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector('[data-gift-form]');
        this.input = this.querySelector('[data-gift-code]');
        this.button = this.querySelector('[data-gift-submit]');
        this.error = this.querySelector('[data-gift-error]');
        this.status = this.querySelector('[data-gift-status]');
        if (!this.form || !this.input || !this.button || !this.error || !this.status) return;

        this.form.noValidate = true;
        this.input.disabled = false;
        this.setPending(false);
        this.form.addEventListener('submit', this.handleSubmit);
        this.input.addEventListener('input', this.handleInput);
        window.addEventListener('pageshow', this.handlePageShow);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit);
        this.input?.removeEventListener('input', this.handleInput);
        window.removeEventListener('pageshow', this.handlePageShow);
        this.controller?.abort();
        this.controller = null;
        this.handoffForm?.remove();
        this.handoffForm = null;
      }

      setPending(pending) {
        this.pending = pending;
        this.button.disabled = pending;
        this.input.readOnly = pending;
        this.form.setAttribute('aria-busy', String(pending));
      }

      clearError() {
        this.error.textContent = '';
        this.error.hidden = true;
        this.input.removeAttribute('aria-invalid');
      }

      showError(message) {
        this.status.textContent = '';
        this.error.hidden = false;
        this.error.textContent = message;
        this.input.setAttribute('aria-invalid', 'true');
        this.input.focus();
      }

      handleInput() {
        if (!this.pending) {
          this.clearError();
          this.status.textContent = '';
        }
      }

      handlePageShow(event) {
        if (!event.persisted) return;
        this.controller?.abort();
        this.controller = null;
        this.handoffForm?.remove();
        this.handoffForm = null;
        this.setPending(false);
        this.clearError();
        this.status.textContent = '';
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.pending) return;
        this.clearError();

        const code = this.input.value.trim();
        if (!code) {
          this.showError(this.dataset.requiredMessage);
          return;
        }

        this.setPending(true);
        this.status.textContent = this.dataset.checkingMessage;
        const controller = new AbortController();
        this.controller = controller;
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        let handedOff = false;

        try {
          const response = await fetch('https://lahjatilaus.decanter.fi/gift-codes/authenticate', {
            method: 'POST',
            credentials: 'omit',
            redirect: 'error',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: new URLSearchParams({ code }),
            signal: controller.signal
          });

          if (!response.ok) throw new Error('Gift service request failed');
          const data = await response.json();
          if (!this.isConnected || this.controller !== controller) return;
          if (!data || typeof data !== 'object' || Array.isArray(data)) {
            throw new Error('Invalid gift service response');
          }

          const accepted = data.result === true || data.result === 1 || data.result === '1' || data.result === 'true';
          const rejected = data.result === false || data.result === 0 || data.result === '0' || data.result === 'false';

          if (rejected) {
            const message = typeof data.msg === 'string' && data.msg.trim()
              ? data.msg
              : this.dataset.invalidMessage;
            this.showError(message);
            return;
          }

          if (!accepted) throw new Error('Invalid gift service result');

          const values = [data.code, data.campaign];
          const validValues = values.every(value =>
            (typeof value === 'string' && value.trim().length > 0) ||
            (typeof value === 'number' && Number.isFinite(value))
          );
          if (!validValues) throw new Error('Missing gift service handoff data');

          const handoff = document.createElement('form');
          handoff.method = 'post';
          handoff.action = 'https://lahjatilaus.decanter.fi/';
          handoff.hidden = true;
          for (const [name, value] of [['code', data.code], ['campaign', data.campaign]]) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = String(value);
            handoff.appendChild(input);
          }
          this.handoffForm = handoff;
          document.body.appendChild(handoff);
          this.status.textContent = this.dataset.redirectingMessage;
          HTMLFormElement.prototype.submit.call(handoff);
          handedOff = true;
        } catch (error) {
          if (!this.isConnected || this.controller !== controller) return;
          this.handoffForm?.remove();
          this.handoffForm = null;
          this.showError(controller.signal.aborted ? this.dataset.timeoutMessage : this.dataset.serviceMessage);
        } finally {
          window.clearTimeout(timeout);
          if (this.controller === controller) {
            this.controller = null;
            if (!handedOff) this.setPending(false);
          }
        }
      }
    }

    customElements.define('decanter-gift-redemption', DecanterGiftRedemption);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviewsio-card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deferred-reviews-carousel')) {
    const assets = new Map();

    const loadAsset = (type, url) => {
      if (assets.has(url)) return assets.get(url);

      const promise = new Promise((resolve, reject) => {
        const asset = document.createElement(type);
        const timeout = setTimeout(() => complete(new Error('Reviews carousel asset timed out')), 15000);
        const complete = (error) => {
          clearTimeout(timeout);
          asset.onload = null;
          asset.onerror = null;
          if (error) {
            assets.delete(url);
            asset.remove();
            reject(error);
          } else {
            resolve();
          }
        };

        if (type === 'script') {
          asset.src = url;
          asset.async = true;
        } else {
          asset.rel = 'stylesheet';
          asset.href = url;
        }
        asset.onload = () => complete();
        asset.onerror = () => complete(new Error('Reviews carousel asset failed'));
        document.head.appendChild(asset);
      });

      assets.set(url, promise);
      return promise;
    };

    customElements.define('deferred-reviews-carousel', class extends HTMLElement {
      connectedCallback() {
        this.generation = (this.generation || 0) + 1;
        if (this.initialized) return;
        this.mount = this.querySelector('[data-reviews-mount]');
        if (!this.mount) return;
        this.removeAttribute('data-ready');
        this.setAttribute('aria-busy', 'true');

        if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
          this.load();
          return;
        }

        this.visibilityObserver = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting)) this.load();
        }, {rootMargin: '600px 0px'});
        this.visibilityObserver.observe(this);
      }

      disconnectedCallback() {
        this.generation += 1;
        this.loading = false;
        this.visibilityObserver?.disconnect();
        this.renderObserver?.disconnect();
        clearTimeout(this.timeout);
        if (this.initialized) this.finish();
      }

      finish() {
        this.setAttribute('data-ready', '');
        this.setAttribute('aria-busy', 'false');
        this.renderObserver?.disconnect();
        clearTimeout(this.timeout);
      }

      async load() {
        if (this.loading || this.initialized || !this.isConnected) return;
        this.loading = true;
        const generation = this.generation;
        this.removeAttribute('data-ready');
        this.setAttribute('aria-busy', 'true');
        this.timeout = setTimeout(() => this.finish(), 15000);

        try {
          const config = JSON.parse(this.querySelector('[data-reviews-config]').textContent);
          await Promise.all([
            window.carouselInlineWidget ? Promise.resolve() : loadAsset('script', 'https://widget.reviews.co.uk/carousel-inline-iframeless/dist.js?_t=2026061914'),
            loadAsset('link', 'https://assets.reviews.io/css/widgets/carousel-widget.css?_t=2026061914'),
            loadAsset('link', 'https://assets.reviews.io/iconfont/reviewsio-icons/style.css?_t=2026061914')
          ]);
          if (!this.isConnected || generation !== this.generation) return;

          this.renderObserver = new MutationObserver(() => {
            if (this.mount.children.length) this.finish();
          });
          this.renderObserver.observe(this.mount, {childList: true});
          new window.carouselInlineWidget(this.mount.id, config);
          this.initialized = true;
          this.visibilityObserver?.disconnect();
        } catch (error) {
          if (!this.isConnected || generation !== this.generation) return;
          this.loading = false;
          this.finish();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
